import { useAppContext } from '../../../AppContext';
import { useCallback } from 'react';
import Channels from './Channels';
import { Page } from '../../../models/Page';
import ChatSidePanel from '../Pages/Chat/SidePanel/ChatSidePanel';
import EmailSidePanel from '../Pages/Email/EmailSidePanel';
import TelephonySidePanel from '../Pages/Telephony/Page/TelephonySidePanel';
import TelephonyWidgetButton from './TelephonyWidgetButton';
import { useTelephonyContext } from '../../../contexts/TelephonyContext';
import { Box, Typography } from '@coolblue-development/freddy';

const SidePanel = (): JSX.Element => {
  const { activePage } = useAppContext();
  const { setSelectedRecentCall } = useTelephonyContext();

  const handleSelectedRecentCall = useCallback(
    (phoneNumber: string, index: number): void => {
      setSelectedRecentCall({ phoneNumber, index });
    },
    [setSelectedRecentCall]
  );

  return (
    <Box
      sx={{
        borderRadius: '8px',
        backgroundColor: '#FFF',
        boxShadow: '0px 4px 16px 0px #246CB429',
        minWidth: '280px',
        position: 'relative',
        margin: '10px',
        overflow: 'hidden'
      }}
    >
      <Channels />
      <Box
        sx={{
          overflow: 'auto',
          height: 'calc(100% - 50px)',
          padding: '0px 16px 12px 16px'
        }}
      >
        <Typography variant="h2" sx={{ marginBottom: '12px' }}>
          Inbox
        </Typography>
        {activePage === Page.CHAT && <ChatSidePanel />}
        {activePage === Page.EMAIL && <EmailSidePanel />}
        {activePage === Page.TELEPHONY && <TelephonySidePanel handleSelectedRecentCall={handleSelectedRecentCall} />}
        <Box sx={{ position: 'absolute', bottom: '16px', left: '16px' }}>
          <TelephonyWidgetButton />
        </Box>
      </Box>
    </Box>
  );
};

export default SidePanel;
